<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>TK {{ $t('Periodic-Report')}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field flat="" solo-inverted="" hide-details v-model="search3" :label="$t('Search')" append-icon="search">
              </v-text-field>

<v-btn color="pink lighten-1" dark @click="openMailDialog" small>
  <v-icon left>email</v-icon> Mail Gönder
</v-btn>

              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>


                  <v-list-tile @click="getListExcel()" v-if="PB=='TRY'">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>


            </v-toolbar>
          </v-flex>

<v-container fluid class="pa-3">
  <v-layout row wrap class="summary-wrap">
    <v-flex xs12 sm4 class="pr-1 pb-1">
      <v-card color="info" dark class="summary-card">
        <v-card-text class="py-2">
          <v-layout row align-center>
            <v-icon class="mr-2">shopping_cart</v-icon>
            <div class="summary-text">
              <div class="summary-title">Toplam Satış</div>
              <div class="summary-value">{{ toplamSatis | money }}</div>
            </div>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>

    <v-flex xs12 sm4 class="px-1 pb-1">
      <v-card color="info" dark class="summary-card">
        <v-card-text class="py-2">
          <v-layout row align-center>
            <v-icon class="mr-2">undo</v-icon>
            <div class="summary-text">
              <div class="summary-title">Toplam İade</div>
              <div class="summary-value">{{ toplamIade | money }}</div>
            </div>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>

    <v-flex xs12 sm4 class="pl-1 pb-1">
      <v-card color="info" dark class="summary-card">
        <v-card-text class="py-2">
          <v-layout row align-center>
            <v-icon class="mr-2">account_balance_wallet</v-icon>
            <div class="summary-text">
              <div class="summary-title">Net Satış</div>
              <div class="summary-value">{{ netSatis | money }}</div>
            </div>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</v-container>


          <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="550px">
            <v-card color="grey lighten-5">
              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>


                <v-layout row="" wrap="">

                  <v-flex xs12 sm6 md12>
                    <v-layout justify-space-between column>
                      <havayollaricomp :etiket="$t('Airline-Code')" v-model="havayolubil"></havayollaricomp>

                      <v-select :items="masrafmerkezi" hide-details v-model="devreRaporu.Masraf" :label="$t('Expense-Center-v2')"
                        item-text="Title" item-value="Code">
                        <template slot="selection" slot-scope="{ item, index }">
                          <v-chip v-if="index === 0">
                            <h4> <span>{{ item.Code }}</span> </h4>
                          </v-chip>
                          <span v-if="index === 1" class="grey--text caption">(+{{
                           devreRaporu.Masraf.length - 1 }} {{ $t('other-record') }})</span>
                        </template>
                      </v-select>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-layout justify-space-between column>
                      <v-checkbox label="Sadece Acentadan Alınanları Bas" v-model="devreRaporu.Opsiyonlar.AcentaBas"
                        hide-details=""></v-checkbox>
                      <v-checkbox :label="$t('All-Companies')" v-model="tumsirketler" hide-details=""></v-checkbox>
                    </v-layout>
                  </v-flex>

                  <v-flex pt-1 xs12 sm12 md12>
                    <div class="card__text grey darken-1 white--text">
                      <h3> {{ $t('Options-v2') }} </h3>
                    </div>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-radio-group v-model="devreRaporu.RaporTipi" :label="$t('Report-Type')" column>
                      <v-radio :label="$t('All')" :value="0"> </v-radio>
                      <v-radio :label="$t('Sales')" :value="1"></v-radio>
                      <v-radio :label="$t('Refund')" :value="2"></v-radio>
                      <v-radio :label="$t('Void')" :value="3"></v-radio>

                    </v-radio-group>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-radio-group v-model="devreRaporu.OdemeSekli" :label="$t('Payment')" column>
                      <v-radio :label="$t('All')" :value="0"></v-radio>
                      <v-radio :label="$t('Cash')" :value="1"> </v-radio>
                      <v-radio :label="$t('Credit-Card')" :value="2"> </v-radio>

                    </v-radio-group>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-radio-group v-model="devreRaporu.SiraTipi" :label="$t('Raport-Order')" column>
                      <v-radio :label="$t('Ticket-Order') + '(S-I-V)'" :value="0"> </v-radio>
                      <v-radio :label="$t('Ticket-Order')" :value="1"> </v-radio>
                    </v-radio-group>
                  </v-flex>



                  <v-flex xs12 sm6 md4>
                    <v-radio-group v-model="devreRaporu.FiyatTur" :label="$t('Price-Type')" column>
                      <v-radio :label="$t('Full-Fare-Ticket')" :value="0"> </v-radio>
                      <v-radio :label="$t('Ticket-without-VAT')" :value="1"></v-radio>
                      <v-radio :label="$t('Ticket-with-VAT')" :value="2"></v-radio>
                    </v-radio-group>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-radio-group v-model="devreRaporu.HatTipi" :label="$t('Line-Type')" column>
                      <v-radio :label="$t('All-v2')" :value="0"> </v-radio>
                      <v-radio :label="$t('Domestic-Line')" :value="1"></v-radio>
                      <v-radio :label="$t('International-Line')" :value="2"></v-radio>
                    </v-radio-group>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-radio-group v-model="devreRaporu.UcusTip" :label="$t('Cyprus-Batum-Flights')" column>
                      <v-radio :label="$t('All-v2')" :value="0"> </v-radio>
                      <v-radio :label="'ECN-BUS' + $t('Excluding') " :value="1"></v-radio>
                      <v-radio :label="$t('Only') +  'ECN-BUS'" :value="2"></v-radio>
                    </v-radio-group>
                  </v-flex>






                </v-layout>

              </v-card-text>

              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

<v-dialog v-model="mailDialog" persistent max-width="640px" scrollable>
  <v-card>
    <v-toolbar dense flat color="info" dark>
      <v-toolbar-title>Mail Gönder</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="closeMailDialog"><v-icon>close</v-icon></v-btn>
    </v-toolbar>

    <v-card-text>
      <v-form ref="mailForm" v-model="mailValid" lazy-validation>
        <v-layout wrap>
          <v-flex xs12>
            <v-text-field
              v-model="mailPayload.To"
              label="Kime (e-posta)"
              :rules="[rules.required, rules.email]"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.AgencyName"
              label="Agency Name"
              :rules="[rules.required]"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.DocType"
              label="Doc Type (sabit)"
              :rules="[rules.required]"
              :disabled="true"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.AgentFullName"
              label="Agent Full Name"
              :rules="[rules.required]"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12>
            <v-textarea
              v-model="mailPayload.CustomBody"
              label="Mesaj"
              :rules="[rules.required]"
              auto-grow
              rows="3"
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>

    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="closeMailDialog">Vazgeç</v-btn>
      <v-btn
        color="info"
        :loading="mailLoading"
        :disabled="!mailValid || mailLoading"
        @click="sendMail"
      >
        <v-icon left>send</v-icon>Gönder
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
          <v-container fluid="">
            <v-card flat="">
              <v-form ref="formcariyegore" v-model="valid" lazy-validation>
                <v-container fluid>
                  <v-card flat>
                    <v-layout row wrap="">

                      <v-flex xs12 sm6 md2>
                        <tarihcomp :etiket="$t('Starting-Date')" :tabindex="'14'" v-bind:defaultvalue="'ok'"
                          v-bind:value="devreRaporu.BaslangicTarih" :rules="[v => !!v || $t('Please-select-a-date')]"
                          v-model="devreRaporu.BaslangicTarih"></tarihcomp>
                      </v-flex>

                      <v-flex xs12 sm6 md2>
                        <tarihcomp :etiket="$t('Finishing-Date')" :rules="[v => !!v || $t('Please-select-a-date')]"
                          :tabindex="'14'" v-bind:defaultvalue="'ok'" v-bind:value="devreRaporu.BitisTarih"
                          v-model="devreRaporu.BitisTarih"></tarihcomp>
                      </v-flex>



                      <v-flex>
                        <v-layout>
                          <div v-if="load1">
                            <v-btn color="info" @click="getList()" fab small="" dark>
                              <v-icon>search</v-icon>
                            </v-btn>
                          </div>
                           <div v-if="load1==false">
                            <v-layout>
                              <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                            </v-layout>
                          </div>
                          <v-badge color="white" :overlap="true">
                            <template v-slot:badge>
                              <v-icon v-if="filtrevarmi" large color="green">
                                check_circle_outline </v-icon>
                            </template>

                            <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                              @click="filtrele()" color="info" fab dark>
                              <v-icon>filter_list</v-icon>
                            </v-btn>
                            <v-tooltip bottom="" :activator="el" v-model="tooltip">
                              <span>{{$t('Add-Search-Filter')}}</span>
                            </v-tooltip>



                          </v-badge>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-container>

              </v-form>
              <v-layout>



                <v-flex xs12 sm12 md12>
                  <v-card flat>

                    <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items"
                      :search="search3">
                      <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                      <template slot="items" slot-scope="props">

                        <td class="text-xs-left">{{ props.item.BiletNo }}</td>
                        <td class="text-xs-left">{{ props.item.CariKod }}</td>
                        <td class="text-xs-left">{{ props.item.S}}</td>
                        <td class="text-xs-left">{{ props.item.C}}</td>
                        <td class="text-xs-left">{{ props.item.UcusTip}}</td>
                        <td class="text-xs-left">{{ props.item.Komisyonlu}}</td>
                        <td class="text-xs-left">{{ props.item.Komisyonsuz }}</td>
                        <td class="text-xs-left">{{ props.item.Vergi }}</td>
                        <td class="text-xs-left">{{ props.item.KA }}</td>
                        <td class="text-xs-left">{{ props.item.YFF }}</td>
                        <td class="text-xs-left">{{ props.item.ToplamTutar }}</td>
                        <td class="text-xs-left">{{ props.item.CezaTutar }}</td>
                        <td class="text-xs-left">{{ props.item.Yuzde }}</td>
                        <td class="text-xs-left">{{ props.item.Komisyon }}</td>
                        <td class="text-xs-left">{{ props.item.FaturaNo }}</td>
                        <td class="text-xs-left">{{ props.item.ExBiletNo }}</td>


                      </template>
       

                      <v-alert slot="no-results" :value="true" color="error" icon="warning">
                          {{ $t('No-records-searched-for', { value: search3}) }}
                      </v-alert>
                    </v-data-table>
                  </v-card>
                  <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
                    :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'"
                    v-model="snackbar">
                    {{ text1 }}
                    <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
                  </v-snackbar>
                </v-flex>
              </v-layout>
            </v-card>
          </v-container>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../../api/auth'
  import tarihcomp from '../../customcomp/tarihim'
  import havayollaricomp from "@/components/app/bilet/partpage/havayollaricomp.vue"
    import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"


  export default {
    data() {
      return {
        toplamSatislar: null,
        toplamIadeler: null,
        netToplam: null,

        mailDialog: false,
        mailValid: false,
        mailLoading: false,
        mailPayload: {
          To: "",
          AgencyName: "",
          DocType: "Kesen Kişi Performans Raporu - Performance Analysis of Ticket Agent", 
          AgentFullName: "",
          CustomBody: ""
        },
        rules: {
          required: v => !!v || 'Zorunlu alan',
          email: v => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Geçerli bir e-posta girin'
        },
        PB:'TRY',
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        filtrevarmi: false,
        search: '',
        havayolubil: {
          havayolukodu: null,
          formno: null
        },

        devreRaporu: {
          SirketKodu: null,
          BaslangicTarih: null,
          BitisTarih: null,
          HavayoluKodu: null,
          Masraf: null,
          OdemeSekli: 0, // 0 : Hepsi, 1: Peşin, 2: KrediKartli
          RaporTipi: 0, // 0 : Hepsi, 1 : Satış, 2: Iade, 3 : Void
          FiyatTur: 0, // 0 : Hepsi, 1 : KdvsizBilet, 2: Kdvli Bilet
          UcusTip: 0, // 0 : Hepsi, 1 : Ecn-Bus Haric vb, 2 : Sadece Ecn-Bus vb
          HatTipi: 0, // 0 : Hepsi, 1 : Ic hat, 2 : Dış hat
          SiraTipi: 0, // 0 : S-I-V, 1 : BiletSirası
          Opsiyonlar: {
            AcentaBas: false
          }
        },
        devirborc: 0,
        deviralacak: 0,
        devirbakiye: 0,
        donemborc: 0,
        donemalacak: 0,
        donembakiye: 0,
        toplamborc: 0,
        toplamalacak: 0,
        toplambakiye: 0,
        valid: true,
        statecari: [],
        searchcari: '',
        Carihesap: '',
        text1: null,
        loading: false,
        progress: false,
        renk1: 'info',
        items: [],
        load: false,
        load1: true,
        search3: '',
        dialogfiltre: false,
        hesapkodu: [],
        Referans: [],
        masrafmerkezi: [],

        tumsirketler: false,

        anahesap: [],
        hesapgurubu: [],
        evraktipi: [],
        mizan: '',
        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        tooltip: false,
        el: null,
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    beforeMount: beforeMount,
    components: {
      tarihcomp,
      havayollaricomp,
      yetkidialog
    },
    mounted() {

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.PB=credentials.ParaBirimi
      this.el = this.$refs.fab.$el
 this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status != true) {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              var url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              var mainUrl = '#/'
              window.open(mainUrl, '_self')
            }
          } 

        });
      } 

    },
    watch: {
    },
    methods: {

  openMailDialog: function () {
    var pageDocType = "TK Devre Raporu - TK Periodic Report";
    if (!this.mailPayload) this.mailPayload = {};
    this.mailPayload.DocType = pageDocType;

    if (this.$refs && this.$refs.mailForm && this.$refs.mailForm.resetValidation) {
      this.$refs.mailForm.resetValidation();
    }

    this.mailDialog = true;
  },

  closeMailDialog: function () {
    this.mailDialog = false;
  },

  sendMail: function () {
    var _this = this;

    if (!(_this.$refs && _this.$refs.mailForm && _this.$refs.mailForm.validate && _this.$refs.mailForm.validate())) {
      return;
    }

    var bas = (_this.devreRaporu && _this.devreRaporu.BaslangicTarih) ? new Date(_this.devreRaporu.BaslangicTarih) : null;
    var bit = (_this.devreRaporu && _this.devreRaporu.BitisTarih) ? new Date(_this.devreRaporu.BitisTarih) : null;
    if (!(bas && bit && bas <= bit)) {
      _this.text1 = _this.$t('start-date-cannot-greater-than-end-date');
      _this.snackbar = true;
      return;
    }

    var credentialsRaw = window.localStorage.getItem('credentials');
    var credentials = credentialsRaw ? JSON.parse(credentialsRaw) : {};
    var companyCode = (_this.tumsirketler === true)
      ? 0
      : (credentials && credentials.SirketKodu) ? credentials.SirketKodu : null;

    var havayoluKod = (_this.havayolubil && _this.havayolubil.havayolukodu) ? _this.havayolubil.havayolukodu : null;

    var inputObj = {
      SirketKodu: companyCode,
      BaslangicTarih: (_this.devreRaporu && _this.devreRaporu.BaslangicTarih) ? _this.devreRaporu.BaslangicTarih : null,
      BitisTarih: (_this.devreRaporu && _this.devreRaporu.BitisTarih) ? _this.devreRaporu.BitisTarih : null,
      HavayoluKodu: havayoluKod,
      Masraf: (_this.devreRaporu && _this.devreRaporu.Masraf) ? _this.devreRaporu.Masraf : null,
      OdemeSekli: (_this.devreRaporu && typeof _this.devreRaporu.OdemeSekli !== 'undefined') ? _this.devreRaporu.OdemeSekli : 0,
      RaporTipi: (_this.devreRaporu && typeof _this.devreRaporu.RaporTipi !== 'undefined') ? _this.devreRaporu.RaporTipi : 0,
      FiyatTur: (_this.devreRaporu && typeof _this.devreRaporu.FiyatTur !== 'undefined') ? _this.devreRaporu.FiyatTur : 0,
      UcusTip: (_this.devreRaporu && typeof _this.devreRaporu.UcusTip !== 'undefined') ? _this.devreRaporu.UcusTip : 0,
      HatTipi: (_this.devreRaporu && typeof _this.devreRaporu.HatTipi !== 'undefined') ? _this.devreRaporu.HatTipi : 0,
      SiraTipi: (_this.devreRaporu && typeof _this.devreRaporu.SiraTipi !== 'undefined') ? _this.devreRaporu.SiraTipi : 0,
      Opsiyonlar: {
        AcentaBas: (_this.devreRaporu && _this.devreRaporu.Opsiyonlar && typeof _this.devreRaporu.Opsiyonlar.AcentaBas !== 'undefined')
          ? _this.devreRaporu.Opsiyonlar.AcentaBas : false
      }
    };

    var pageDocType = "TK Devre Raporu - TK Periodic Report";
    var mailObj = {
      To: (_this.mailPayload && _this.mailPayload.To) ? _this.mailPayload.To : "",
      AgencyName: (_this.mailPayload && _this.mailPayload.AgencyName) ? _this.mailPayload.AgencyName : "",
      DocType: (_this.mailPayload && _this.mailPayload.DocType) ? _this.mailPayload.DocType : pageDocType,
      AgentFullName: (_this.mailPayload && _this.mailPayload.AgentFullName) ? _this.mailPayload.AgentFullName : "",
      CustomBody: (_this.mailPayload && _this.mailPayload.CustomBody) ? _this.mailPayload.CustomBody : ""
    };

    var payload = { Input: inputObj, Mail: mailObj };

    _this.mailLoading = true;

    var endpoint = auth.API_URL + 'api/TicketPeriodReport/MailGonderTkDevreRaporuExcel';

    _this.$http.post(
      endpoint,
      payload,
      { headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() } }
    ).then(function () {
      _this.mailLoading = false;
      _this.mailDialog = false;
      _this.text1 = 'Mail gönderildi.';
      _this.snackbar = true;
    }, function (err) {
      _this.mailLoading = false;
      var body = (err && (err.body || err.data)) ? (err.body || err.data) : {};
      var msg = (body && (body.Message || body.message)) || err.statusText || 'Mail gönderilemedi.';
      _this.text1 = msg;
      _this.snackbar = true;
    });
  },


      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal,
    },
    computed:{
        headers(){
          return [{
            text: this.$t('Ticket-No'),
            value: 'BiletNo'
          },
          {
            text: this.$t('Currentcode_label'),
            value: 'CariKod'
          },
          {
            text: 'S',
            value: 'S'
          },
          {
            text: 'C',
            value: 'C'
          },
          {
            text: this.$t('Flight-Type'),
            value: 'UcusTip'
          },
          {
            text: this.$t('With-commission'),
            value: 'Komisyonlu'
          },
          {
            text: this.$t('Without-commission'),
            value: 'Komisyonsuz'
          },
          {
            text: this.$t('Tax-v2'),
            value: 'Vergi'
          },
          {
            text: 'KA',
            value: 'KA'
          },
          {
            text: 'YFF',
            value: 'YFF'
          },
          {
            text: this.$t("totalamount"),
            value: 'ToplamTutar'
          },
          {
            text: this.$t('Penalty-Amount'),
            value: 'CezaTutar'
          },
          {
            text: this.$t('Percentage'),
            value: 'Yuzde'
          },
          {
            text: this.$t('Commission'),
            value: 'Komisyon'
          },
          {
            text: this.$t('Invoice-No'),
            value: 'FaturaNo'
          },
          {
            text: this.$t('EX-Ticket-No'),
            value: 'ExBiletNo'
          }
        ]
        },
    }
  }








  function filtrele() {
    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params3 = {
      CompanyCode: credentials.SirketKodu
    }


    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.masrafmerkezi = response.body
    }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
    })

  }

  function filtrekayit() {
    this.filtrevarmi = true,
      this.dialogfiltre = false
    this.getList();
  }

  function filtreiptal() {
    this.filtrevarmi = false
    this.dialogfiltre = false
    this.tumsirketler=false
    this.havayolubil.havayolukodu=null
    this.devreRaporu.HavayoluKodu = null
    this.devreRaporu.Masraf = null
    this.devreRaporu.OdemeSekli = 0 // 0 : Hepsi, 1: Peşin, 2: KrediKartli
    this.devreRaporu.RaporTipi = 0 // 0 : Hepsi, 1 : Satış, 2: Iade, 3 : Void
    this.devreRaporu.FiyatTur = 0 // 0 : Hepsi, 1 : KdvsizBilet, 2: Kdvli Bilet
    this.devreRaporu.UcusTip = 0 // 0 : Hepsi, 1 : Ecn-Bus Haric vb, 2 : Sadece Ecn-Bus vb
    this.devreRaporu.HatTipi = 0 // 0 : Hepsi, 1 : Ic hat, 2 : Dış hat
    this.devreRaporu.SiraTipi = 0 // 0 : S-I-V, 1 : BiletSirası
    this.devreRaporu.Opsiyonlar.AcentaBas = false
  }




  function getList() {


    if (this.$refs.formcariyegore.validate()) {


      var bastarih = new Date(this.devreRaporu.BaslangicTarih)
      var bittarih = new Date(this.devreRaporu.BitisTarih)

      if (bastarih <= bittarih) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler == true) {
          this.devreRaporu.SirketKodu = 0
        } else {
          this.devreRaporu.SirketKodu = credentials.SirketKodu
        }

        this.progress = true

        this.devreRaporu.HavayoluKodu = this.havayolubil.havayolukodu;

        var params = this.devreRaporu

        this.load1 = false

        this.$http.post(auth.API_URL + 'api/TicketPeriodReport/TKPeriodReport', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {


          if (response.body.BiletListe.length != 0) {
            this.progress = false;
            this.load1 = true;
            this.items = response.body.BiletListe;

            this.toplamSatis = (response.body.ToplamSatislar && response.body.ToplamSatislar.ToplamTutar) || 0;
            this.toplamIade  = (response.body.ToplamIadeler  && response.body.ToplamIadeler.ToplamTutar)  || 0;
            this.netSatis    = (response.body.NetToplam      && response.body.NetToplam.ToplamTutar)      || 0;

          } else {
            this.text1 = this.$t('No-Records-Found');
            this.snackbar = true;
            this.progress = false;
            this.load1 = true;
            this.items = [];
          }

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true

            this.load1 = true
            this.progress = false

          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.load1 = true
            this.progress = false

          }
        })

      } else {

        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }

    }



  }


  function getListHtml() {

    if (this.$refs.formcariyegore.validate()) {

      this.progress = true
      this.load1 = false


      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      var lang = localStorage.getItem('lang')
      if (this.tumsirketler == true) {
        this.devreRaporu.SirketKodu = 0
      } else {
        this.devreRaporu.SirketKodu = credentials.SirketKodu
      }



      this.devreRaporu.HavayoluKodu = this.havayolubil.havayolukodu;

      var params = this.devreRaporu


      this.$http
        .post(auth.API_URL + "api/TicketPeriodReport/TKPeriodReportHtml", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          }
        }).then((response) => {
          this.progress = false
          this.load1 = true
          if (lang=='en')
{
             var bodyhtml=helpers.getTranslatedHtml(response.bodyText);
             bodyhtml=bodyhtml.toString().replace('<title> THY DEVRE RAPORU </title>','<title> THY REPORT </title>');
             bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>THY DEVRE RAPORU</font>","<font face = 'Arial' size = '4' color = '#FFFFF0'>THY REPORT</font>");
             bodyhtml=bodyhtml.toString().replace("Seçenekler :","Options :");
             bodyhtml=bodyhtml.toString().replace("Fiyat Türü :","Price Type :");
             bodyhtml=bodyhtml.toString().replace("Seçenekler :	","Options :");
             bodyhtml=bodyhtml.toString().replace("Kesen Kişi :","Person Issuing Tickets :");
             bodyhtml=bodyhtml.toString().replace("Hesap Grubu :","Account Group :");
             bodyhtml=bodyhtml.toString().replaceAll("Bilet No","Ticket No");
             bodyhtml=bodyhtml.toString().replaceAll("Bilet Amountı","Ticket Amount");
             bodyhtml=bodyhtml.toString().replace("Hesap","Account");
             bodyhtml=bodyhtml.toString().replaceAll("Vergi","Tax");
             bodyhtml=bodyhtml.toString().replaceAll("İskonto","Discount");
             bodyhtml=bodyhtml.toString().replaceAll("Kredili","With Credit");
             bodyhtml=bodyhtml.toString().replaceAll("Peşin","Cash");
             bodyhtml=bodyhtml.toString().replaceAll("Fatura No","Invoice No");
             bodyhtml=bodyhtml.toString().replaceAll("Ceza","Penalty");
             bodyhtml=bodyhtml.toString().replaceAll("Yolcu Name","Passanger Name");
             bodyhtml=bodyhtml.toString().replaceAll("Servis","Service")
             bodyhtml=bodyhtml.toString().replaceAll("Bilet Tutarı","Ticket Amount")
             bodyhtml=bodyhtml.toString().replaceAll("SATIŞ TOTALS","SALES TOTALS")
             bodyhtml=bodyhtml.toString().replaceAll("İade Service","Return Service")
             bodyhtml=bodyhtml.toString().replaceAll("R-Kredi Kartlı","R-With Credit Card")
             bodyhtml=bodyhtml.toString().replaceAll("C-Kredi Kartlı","C-With Credit Card")
             bodyhtml=bodyhtml.toString().replaceAll("Hesap","Account")
             bodyhtml=bodyhtml.toString().replaceAll("İç Hat :","Domestic line :")
             bodyhtml=bodyhtml.toString().replaceAll("Dış Hat :","International line :")
             bodyhtml=bodyhtml.toString().replaceAll("Toplam :","Total :")
             bodyhtml=bodyhtml.toString().replace("SATILAN BİLETLER","TICKETS SOLD");
             bodyhtml=bodyhtml.toString().replace("İADE EDİLEN BİLETLER","REFUNDED TICKETS");
             bodyhtml=bodyhtml.toString().replace("VOİD BİLETLER","VOID TICKETS");
             bodyhtml=bodyhtml.toString().replace("KAR TOPLAMLARI"," PROFIT TOTALS")
             bodyhtml=bodyhtml.toString().replace("TOPLAMLAR","TOTALS")
             bodyhtml=bodyhtml.toString().replace("İADE TOPLAMLAR","REFUND TOTALS")
             bodyhtml=bodyhtml.toString().replace("NET TOPLAMLAR","NET TOTALS")
             bodyhtml=bodyhtml.toString().replaceAll("Bu bilet void olmuştur","This ticket has been void")
             bodyhtml=bodyhtml.toString().replaceAll("Masraf :","Cost :")
             bodyhtml=bodyhtml.toString().replaceAll("Ödeme Typei :","Payment Type :")
             bodyhtml=bodyhtml.toString().replaceAll("Komisyon","Commision")
             bodyhtml=bodyhtml.toString().replaceAll("Commisionlu","With Commision")
             bodyhtml=bodyhtml.toString().replaceAll("Commisionsuz","Without Commision")
             bodyhtml=bodyhtml.toString().replaceAll("Hepsi","All")
             bodyhtml=bodyhtml.toString().replaceAll("Tüm Biletler","All Ticket")
             
             response.bodyText=bodyhtml;
             console.log(bodyhtml);
          }
          var blob = new Blob([response.bodyText], {
            type: 'application/html'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = "TKPeriodic.html";
          link.click();
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })

    }



  }


  function getListExcel() {

    if (this.$refs.formcariyegore.validate()) {

      this.progress = true
      this.load1 = false


      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      if (this.tumsirketler == true) {
        this.devreRaporu.SirketKodu = 0
      } else {
        this.devreRaporu.SirketKodu = credentials.SirketKodu
      }



      this.devreRaporu.HavayoluKodu = this.havayolubil.havayolukodu;

      var params = this.devreRaporu


      this.$http
        .post(auth.API_URL + "api/TicketPeriodReport/TKPeriodReportExcel", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          },
          responseType: "arraybuffer"
        }).then((response) => {
          this.progress = false
          this.load1 = true
          var blob = new Blob([response.data], {
            type: 'application/xlsx'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = "TKDevre.xlsx";
          link.click();
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })

    }



  }

  function beforeMount() {


  }


  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  }
</script>

<style>

</style>